(function () {
  console.log('[ev-countdown] script loaded');

  // 同じ要素に複数回 setInterval しないための管理用
  var timers = new WeakMap();

  function initCountdown(el) {
    var tsAttr = el.getAttribute('data-release-ts');
    console.log('[ev-countdown] initCountdown target:', el, 'ts =', tsAttr);

    if (!tsAttr) return;

    var releaseTs = parseInt(tsAttr, 10); // 秒
    if (isNaN(releaseTs)) {
      console.warn('[ev-countdown] invalid timestamp:', tsAttr);
      return;
    }

    var daysEl = el.querySelector('[data-unit="days"]');
    var hoursEl = el.querySelector('[data-unit="hours"]');
    var minutesEl = el.querySelector('[data-unit="minutes"]');
    var secondsEl = el.querySelector('[data-unit="seconds"]');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
      console.warn('[ev-countdown] unit elements not found');
      return;
    }

    // すでにタイマーがあればクリア
    if (timers.has(el)) {
      clearInterval(timers.get(el));
      timers.delete(el);
    }

    function pad(num) {
      return num < 10 ? '0' + num : String(num);
    }

    function update() {
      var nowMs = Date.now();
      var diffMs = releaseTs * 1000 - nowMs;

      // 発売開始を過ぎたら 00:00:00 で止める
      if (diffMs <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      var totalSec = Math.floor(diffMs / 1000);
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    update();
    var id = setInterval(update, 1000);
    timers.set(el, id);
  }

  function initAllCountdowns() {
    var els = document.querySelectorAll('.ev-countdown-inline[data-release-ts]');
    console.log('[ev-countdown] found elements:', els.length);
    els.forEach(initCountdown);

    // ★ カウントダウンがあるページでは body にフラグを立てる
    if (els.length > 0) {
      document.body.classList.add('ev-countdown-active');
    } else {
      document.body.classList.remove('ev-countdown-active');
    }
  }

  // ページの全部の読み込みが終わってから初期化
  if (document.readyState === 'complete') {
    initAllCountdowns();
  } else {
    window.addEventListener('load', initAllCountdowns);
  }

  // テーマエディタ用
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllCountdowns);
    document.addEventListener('shopify:section:reorder', initAllCountdowns);
  }
})();
